import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container solution-header-inner" }
const _hoisted_3 = { class: "solution-heading" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "portal-info solution-info" }
const _hoisted_7 = {
  key: 0,
  id: "current-user-info",
  class: "user"
}
const _hoisted_8 = { class: "username weight-semibold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "company-name weight-normal" }
const _hoisted_11 = { class: "nav" }
const _hoisted_12 = {
  class: "button button-tertiary button-menu-close js-menu-close",
  title: "Luk mobil menu"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1)
const _hoisted_14 = { class: "portal-info-mobile" }
const _hoisted_15 = {
  key: 0,
  class: "user bold"
}
const _hoisted_16 = { class: "solution-info-mobile" }
const _hoisted_17 = { class: "bold" }
const _hoisted_18 = {
  href: "javascript:void(0);",
  "data-module": "modal",
  "data-target": "modal-contact",
  class: "function-link d-inline-block"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#card-text" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavBar = _resolveComponent("NavBar")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: "solution-header",
      style: _normalizeStyle([ _ctx.showTestHeader ? {backgroundColor: '#FEBB30'} : {}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            title: this.contentfulTcoModel.findKlarTekst('tco.sidehoved.knap.hjem'),
            class: "alert-leave2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.overskrift' }, null, 8, ["tekstNoegle"]),
              (_ctx.showTestHeader)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.test-header' }, null, 8, ["tekstNoegle"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _createElementVNode("button", {
          class: "button button-secondary button-menu-open js-menu-open ml-auto d-print-none",
          "aria-haspopup": "menu",
          title: _ctx.menuTitle
        }, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.menu.overskrift' }, null, 8, ["tekstNoegle"])
        ], 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.isAuthenticated && _ctx.currentUser.profile)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currentUser.profile.name), 1),
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currentUser.profile['dk:gov:org_name'] || ''), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                id: "logout-button",
                class: "button button-secondary alert-leave d-print-none",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
              }, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.log-af' }, null, 8, ["tekstNoegle"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                id: "login-button",
                class: "button button-secondary alert-leave d-print-none",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.login()))
              }, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.log-ind' }, null, 8, ["tekstNoegle"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 4),
    _createElementVNode("nav", _hoisted_11, [
      _createElementVNode("button", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.luk' }, null, 8, ["tekstNoegle"])
      ]),
      _createVNode(_component_NavBar),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.isAuthenticated && _ctx.currentUser.profile)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.currentUser.profile.name), 1))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: "#",
              class: "button button-secondary button-signout",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
            }, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.log-af' }, null, 8, ["tekstNoegle"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: "#",
              class: "button button-secondary button-signout",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.login()))
            }, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.log-ind' }, null, 8, ["tekstNoegle"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", _hoisted_17, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.ministerium' }, null, 8, ["tekstNoegle"])
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.kontakt' }, null, 8, ["tekstNoegle"])
          ])
        ])
      ])
    ])
  ]))
}